import { render, staticRenderFns } from "./IdeasList.vue?vue&type=template&id=58940ec6&scoped=true&"
import script from "./IdeasList.vue?vue&type=script&lang=js&"
export * from "./IdeasList.vue?vue&type=script&lang=js&"
import style0 from "./IdeasList.vue?vue&type=style&index=0&id=58940ec6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58940ec6",
  null
  
)

export default component.exports